import { dataDollarCircle } from 'dls-icons-data'
import { createIcon } from '../common'

const IconDollarCircle = /*#__PURE__*/createIcon(dataDollarCircle)
export default IconDollarCircle
